import gql from 'graphql-tag';

export default gql`
  fragment groupCommentFragment on GroupCommentType {
    id
    groupActivityId
    userId
    message
    createdAtText
    isEdit
    isRemove
  }
`;
